import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { BRAND } from '../constants/brand';
import { PRODUCTS } from '../constants/products';
import logoMark from '../assets/new_theme.png';

const Footer = () => {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={logoMark}
                alt={BRAND.logoAlt}
                className="h-10 w-10 rounded-xl ring-1 ring-slate-200/80 shadow-sm object-contain bg-white"
                width={40}
                height={40}
              />
              <div>
                <p className="font-display font-semibold text-slate-900 text-lg">{BRAND.displayName}</p>
                <p className="text-sm text-slate-500">{BRAND.tagline}</p>
              </div>
            </div>
            <p className="text-slate-600 text-sm max-w-md leading-relaxed">
              We help organizations plan, build, and run reliable technology—with security and outcomes
              at the center of every engagement.
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Contact</p>
            <ul className="space-y-3 text-sm text-slate-600">
              <li className="flex items-start gap-2">
                <FiMail className="mt-0.5 shrink-0 text-brand-cyan" />
                <a href={`mailto:${BRAND.contact.email}`} className="hover:text-brand-violet transition-colors">
                  {BRAND.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <FiMapPin className="mt-0.5 shrink-0 text-brand-amber" />
                <span>{BRAND.contact.city}</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Apps</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="text-slate-600 hover:text-brand-violet transition-colors">
                  All apps
                </Link>
              </li>
              {PRODUCTS.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/products/${p.slug}`}
                    className="text-slate-600 hover:text-brand-violet transition-colors"
                  >
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Legal</p>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-slate-600 hover:text-brand-violet transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-slate-600 hover:text-brand-violet transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-slate-600 hover:text-brand-violet transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>© {BRAND.copyrightYear} {BRAND.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
